import React from 'react';
import {
  Badge, Table, OverlayTrigger, Tooltip,
} from 'react-bootstrap';

import { floatRenderer } from '../../../services/formatSvc';
import {getCurrentStyle} from "../../../helpers/passport";

export default function BudgetTableFb({status, data, finSource, acceptedData, strategyType, isNew }) {
  const renderRow = (d,index) => {
    const findInSources = (type,element) =>finSource.sources[type] && finSource.sources[type]?.find((argument) => argument.id === element);

    const acceptedElement = acceptedData && acceptedData?.[index];
    const [agreement,acceptedAgreement] = [findInSources('agreements',d?.agreementId), findInSources('agreements',acceptedElement?.agreementId) ];
    const [bcCode,acceptedBcCode] = [findInSources('bcCodes',d?.bcCodeId),findInSources('bcCodes',acceptedElement?.bcCodeId)];
    const [funding,acceptedFunding] = [findInSources('funding',d?.fundingId),findInSources('funding',acceptedElement?.fundingId)];

    return (
      <tr key={d.id}>
        <td>{d.year}</td>
        <td style={getCurrentStyle(status,agreement,acceptedAgreement,'name')}>{agreement && agreement.name}</td>
        <td style={getCurrentStyle(status,bcCode,acceptedBcCode,'fullCode')}>{bcCode && bcCode.fullCode}</td>
        {!isNew && (
          <td style={getCurrentStyle(status, funding, acceptedFunding, 'name')}>
            {funding && funding.name}
          </td>
        )}
        <td style={getCurrentStyle(status,d,acceptedElement,'sum')}>
          {floatRenderer(d.sum)}
&nbsp;
          {!!d.remainder && (
          <OverlayTrigger overlay={(
            <Tooltip id="tooltip-remainder">
              Превышение остатка по плану
              {' '}
              {d.isPortf ? 'портфеля' : strategyType === 'strategy' ? 'СП' : 'политики'}
              :
              {' '}
              {floatRenderer(d.remainder)}
            </Tooltip>
        )}
          >
            <Badge pill bg="danger">!</Badge>
          </OverlayTrigger>
          )}
        </td>
      </tr>
    );
  };

  return (
    <Table striped className="read-view">
      <thead>
        <tr>
          <th>Год</th>
          <th>Соглашение</th>
          <th>Код подраздела БК</th>
          {!isNew && <th>Тип финансирования</th>}
          <th>План, руб</th>
        </tr>
      </thead>
      <tbody>
        {data.map((el,index)=>renderRow(el,index))}
      </tbody>
    </Table>
  );
}
